import { DOCUMENTO_ASSINADO_LOAD, DOCUMENTO_ASSINADO_UNLOAD } from "../../actions/Constants";

const INITIAL_STATE = { all: [] };

export default function documentoAssinado(state = INITIAL_STATE, action) {
  switch (action.type) {
    case DOCUMENTO_ASSINADO_LOAD:
      return {
        ...state,
        all: action.payload ? action.payload : [],
      };
    case DOCUMENTO_ASSINADO_UNLOAD:
      return INITIAL_STATE;
    default:
      return state;
  }
}
